// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PzaLkbAEAxHVVwrzn42V {
  background: var(--ocean-gradient);
  border: var(--map-popup-border);
  border-radius: var(--map-popup-border-radius);
  box-shadow: var(--map-popup-box-shadow);
  max-width: clamp(25vw, 66vw, 280px);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  box-sizing: border-box;
}

.Ok0IoDDeBujD1mxC8RL0 {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  overflow: hidden;
  gap: 0.25rem;
  padding: 1rem;
  border-bottom: var(--accent-border);
  border-radius: var(--map-popup-border-radius) var(--map-popup-border-radius) 0
    0;
}

.CMi4a_8m9RA1AjRsvvLM {
  text-overflow: ellipsis;
  font-weight: var(--map-h2-font-weight);
  color: #fff;
}

.vSO6UuPsXiDHXyCExdSS {
  all: unset;
  width: 1rem;
  height: 1rem;
  cursor: pointer;
  filter: invert(1);
}

.d9jk49H0lE3gZY_StqqT {
  background: var(--map-popup-background-color);
  border-radius: 0 0 var(--map-popup-border-radius) var(--map-popup-border-radius);
  padding: var(--map-popup-content-padding--scrollable);
  box-shadow: var(--map-popup-box-shadow-inner);
  overflow: hidden;
}

.yXRuCQrhSKtKx5jiSGAi {
  overflow-y: auto;
  padding: var(--map-popup-content-padding);
}
`, "",{"version":3,"sources":["webpack://./../core/components/shared/Dialog.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,6CAA6C;EAC7C,uCAAuC;EACvC,mCAAmC;EACnC,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC;KACG;AACL;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,gFAAgF;EAChF,qDAAqD;EACrD,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C","sourcesContent":[".container {\r\n  background: var(--ocean-gradient);\r\n  border: var(--map-popup-border);\r\n  border-radius: var(--map-popup-border-radius);\r\n  box-shadow: var(--map-popup-box-shadow);\r\n  max-width: clamp(25vw, 66vw, 280px);\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.headerContainer {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto;\r\n  align-items: center;\r\n  overflow: hidden;\r\n  gap: 0.25rem;\r\n  padding: 1rem;\r\n  border-bottom: var(--accent-border);\r\n  border-radius: var(--map-popup-border-radius) var(--map-popup-border-radius) 0\r\n    0;\r\n}\r\n\r\n.headerText {\r\n  text-overflow: ellipsis;\r\n  font-weight: var(--map-h2-font-weight);\r\n  color: #fff;\r\n}\r\n\r\n.closeButton {\r\n  all: unset;\r\n  width: 1rem;\r\n  height: 1rem;\r\n  cursor: pointer;\r\n  filter: invert(1);\r\n}\r\n\r\n.contentContainer {\r\n  background: var(--map-popup-background-color);\r\n  border-radius: 0 0 var(--map-popup-border-radius) var(--map-popup-border-radius);\r\n  padding: var(--map-popup-content-padding--scrollable);\r\n  box-shadow: var(--map-popup-box-shadow-inner);\r\n  overflow: hidden;\r\n}\r\n\r\n.content {\r\n  overflow-y: auto;\r\n  padding: var(--map-popup-content-padding);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PzaLkbAEAxHVVwrzn42V`,
	"headerContainer": `Ok0IoDDeBujD1mxC8RL0`,
	"headerText": `CMi4a_8m9RA1AjRsvvLM`,
	"closeButton": `vSO6UuPsXiDHXyCExdSS`,
	"contentContainer": `d9jk49H0lE3gZY_StqqT`,
	"content": `yXRuCQrhSKtKx5jiSGAi`
};
module.exports = ___CSS_LOADER_EXPORT___;
